module.exports = __webpack_public_path__ + "static/media/Megalabs.557bd2f6.png";